import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { usePrefs } from "@/lib/context";

const TYPES = { eau: { fr: "Eau", en: "Water" }, gaz: { fr: "Gaz", en: "Gas" }, electricite: { fr: "Électricité", en: "Electricity" } };
export const meterLabel = (type, lang) => TYPES[type]?.[lang] || type;

export function MetersEditor({ value, onChange }) {
  const { lang, t } = usePrefs();
  const set = (i, k, v) => onChange(value.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  return (
    <div className="space-y-2" data-testid="meters-editor">
      {value.map((m, i) => (
        <div key={i} className="grid grid-cols-[110px_1fr_100px_28px] gap-2">
          <Select value={m.type} onValueChange={(v) => set(i, "type", v)}>
            <SelectTrigger className="h-9 rounded-sm" data-testid={`meter-type-${i}`}><SelectValue /></SelectTrigger>
            <SelectContent>{Object.keys(TYPES).map((k) => <SelectItem key={k} value={k}>{meterLabel(k, lang)}</SelectItem>)}</SelectContent>
          </Select>
          <Input className="h-9 rounded-sm font-data text-xs" placeholder="N°" value={m.number} onChange={(e) => set(i, "number", e.target.value)} data-testid={`meter-number-${i}`} />
          <Input className="h-9 rounded-sm font-data text-xs" type="number" placeholder="Index" value={m.last_reading ?? ""} onChange={(e) => set(i, "last_reading", e.target.value === "" ? null : Number(e.target.value))} data-testid={`meter-reading-${i}`} />
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="text-slate-400 hover:text-rose-600"><X size={15} /></button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...value, { type: "eau", number: "", last_reading: null }])} data-testid="add-meter-button" className="flex items-center gap-1 text-xs font-semibold text-[#996515] hover:underline">
        <Plus size={13} /> {t("meters")}
      </button>
    </div>
  );
}

export function MetersList({ meters }) {
  const { lang } = usePrefs();
  if (!meters?.length) return <span className="text-sm text-slate-400">—</span>;
  return (
    <div className="space-y-1.5">
      {meters.map((m, i) => (
        <div key={i} className="flex items-center justify-between gap-3 text-sm">
          <span className="text-slate-600">{meterLabel(m.type, lang)} <span className="font-data text-xs text-slate-400">{m.number}</span></span>
          <span className="font-data text-xs">{m.last_reading ?? "—"}</span>
        </div>
      ))}
    </div>
  );
}
